import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";

import correios from "../../assets/correios-logo.png";
import * as Styles from "./styles";

import { phoneMask } from "../../../utils";
import { rawMsisdn } from "../../utils";

import { Button, Input } from "../../components";
import { useAuthentication } from "../../hooks";
import { useActions } from "../../provider";

export function AuthForm() {
  const { search } = useLocation();
  const channel = search.split("=")[1];

  const { register, handleSubmit } = useForm();
  const { setIsLoading, stepManager } = useActions();
  const { handleValidatePhone, handleUpdateAuthToken } = useAuthentication({
    setIsLoading,
  });

  const { setActionsState } = useActions();

  const onSubmit = async (data) => {
    const MAX_LENGTH = 13;
    const phone = rawMsisdn(data?.number);
    if (phone.length < MAX_LENGTH) return;

    setActionsState({
      msisdn: phone,
    });

    await handleValidatePhone({
      phone,
      channel,
      onValidate: () => stepManager.next(),
    });
  };

  useEffect(() => {
    handleUpdateAuthToken(null);
  }, []);

  return (
    <Styles.Form onSubmit={handleSubmit(onSubmit)}>
      <img src={correios} alt="Logo Mvno" />
      <Input
        type="text"
        name="numberClient"
        {...register("number")}
        required
        placeholder="Insira seu número aqui"
        maxLength={15}
        onKeyUp={(event) => (event.target.value = phoneMask(event))}
      />
      <Button type="submit">VER PLANOS</Button>
    </Styles.Form>
  );
}
